/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RagIngestSummaryDto } from '../../models/rag-ingest-summary-dto';

export interface RagControllerIngest$Params {
}

export function ragControllerIngest(http: HttpClient, rootUrl: string, params?: RagControllerIngest$Params, context?: HttpContext): Observable<StrictHttpResponse<RagIngestSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, ragControllerIngest.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RagIngestSummaryDto>;
    })
  );
}

ragControllerIngest.PATH = '/rag/ingest';
